import(/* webpackMode: "eager" */ "/app/src/app/software-integration/layout.js");
